import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'
import clsx from 'clsx'

import DateFormat from '../../utils/dateFormat'
import CheckboxToggle from '../../utils/CheckboxToggleRemix'
import { updateAvailabilityRequest } from '../../../actions/availabilityRequestsActions'
import Skeleton from 'react-loading-skeleton'

const ShowDetails = ({ match }) => {
  const dispatch = useDispatch()
  const user = useSelector(store => store.admin.user)
  const fetching = useMemo(() => !user.id, [user.id])

  const toggleSms = () => dispatch(updateAvailabilityRequest(user.uuid, { notify_sms: !user.notifySms }))

  const MetaWrapper = ({ children }) => <div className="">{children}</div>
  const MetaHeader = ({ children }) => <div className="tracking-wide text-sm text-gray-400">{children}</div>
  const MetaDetail = ({ children, width }) => (
    <div className="text-xl">{!fetching ? children : <Skeleton width={width} />}</div>
  )
  const StatsValue = ({ children, width }) => (
    <div className="text-xl md:text-3xl lg:text-4xl">{!fetching ? children : <Skeleton width={width} />}</div>
  )

  return (
    <div className={clsx('grid grid-flow-col gap-y-2 gap-x-4 grid-rows-4 mt-4')}>
      <MetaWrapper>
        <MetaHeader>Total Requests</MetaHeader>
        <StatsValue width="2ch">{user.availabilityRequestsCount}</StatsValue>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Active Requests</MetaHeader>
        <StatsValue width="2ch">{user.availabilityRequestsActiveCount}</StatsValue>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Account Created</MetaHeader>
        <MetaDetail width="12ch">
          {user.createdAt && <DateFormat format="MM/DD/YYYY" date={user.createdAt} />}
        </MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Premium</MetaHeader>
        <MetaDetail width="16ch">
          <CheckboxToggle label="Premium" checked={user.premium} onChange={toggleSms} />
        </MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>SMS Count</MetaHeader>
        <StatsValue width="2ch">{user.smsCount}</StatsValue>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>SMS Limit</MetaHeader>
        <StatsValue width="2ch">{user.smsLimit}</StatsValue>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Payment Amount</MetaHeader>
        <StatsValue width="5ch">
          ${user.paymentTotal || 0} <span className="text-gray-400 text-sm">({user.paymentCount || 0})</span>
        </StatsValue>
      </MetaWrapper>

    </div>
  )
}

export default ShowDetails
